const BANNER_WRAP_ITEM_COUNT = 4;
const AD_SOURCE_COSTCO = "costco";
const AD_SOURCE_AD_BUTLER = "adbutler";
const AD_SOURCE_ADOBE = "adobe";
const AD_SOURCE_CRITEO = "criteo";
const AD_SOURCE_LW = "lucidworks";
const BANNER_ITEM_TYPE = "banner";
const PRODUCT_ITEM_TYPE = "product";
const CATEGORY_ITEM_TYPE = "category";
const AD_SET_STYLE_STATIC = "static";
const AD_SET_STYLE_ROTATING = "rotating";
const AD_TYPE_ONE_FOURTH_MIX = "one_fourth_mix";
const AD_TYPE_ONE_FOURTH = "one_fourth";
const AD_TYPE_LARGE_BANNER = "large_banner";
const AD_BUTLER_ENDPOINT = "https://media-cdn.costco.com/adserve/";
const AD_BUTLER_CONTENTSTACK_DEVELOPMENT_KEY = "adbutler_service_config";
const AD_BUTLER_NO_ADS_STATUS = "NO_ADS";
const AD_BUTLER_SUCCESS_STATUS = "SUCCESS";
const AD_BUTLER_TIME_DELAY_IN_MS = 1e3;
const INTERSECTION_THRESHOLD = 0.5;
const CRITEO_TIME_DELAY_IN_MS = 1e3;
const CRITEO_INTERSECTION_THRESHOLD = 0.5;
const MIN_CATEGORY_TILES = 3;
const ITEM_COUNT_DIVISOR = 3;
const MAX_CATEGORY_TILES = 12;
const ITEMS_PER_SLIDE_DESKTOP = 6;
const ITEMS_PER_SLIDE_TABLET = 4;
const ITEMS_PER_SLIDE_MOBILE = 3;
export {
  AD_BUTLER_CONTENTSTACK_DEVELOPMENT_KEY,
  AD_BUTLER_ENDPOINT,
  AD_BUTLER_NO_ADS_STATUS,
  AD_BUTLER_SUCCESS_STATUS,
  AD_BUTLER_TIME_DELAY_IN_MS,
  AD_SET_STYLE_ROTATING,
  AD_SET_STYLE_STATIC,
  AD_SOURCE_ADOBE,
  AD_SOURCE_AD_BUTLER,
  AD_SOURCE_COSTCO,
  AD_SOURCE_CRITEO,
  AD_SOURCE_LW,
  AD_TYPE_LARGE_BANNER,
  AD_TYPE_ONE_FOURTH,
  AD_TYPE_ONE_FOURTH_MIX,
  BANNER_ITEM_TYPE,
  BANNER_WRAP_ITEM_COUNT,
  CATEGORY_ITEM_TYPE,
  CRITEO_INTERSECTION_THRESHOLD,
  CRITEO_TIME_DELAY_IN_MS,
  INTERSECTION_THRESHOLD,
  ITEMS_PER_SLIDE_DESKTOP,
  ITEMS_PER_SLIDE_MOBILE,
  ITEMS_PER_SLIDE_TABLET,
  ITEM_COUNT_DIVISOR,
  MAX_CATEGORY_TILES,
  MIN_CATEGORY_TILES,
  PRODUCT_ITEM_TYPE
};
